import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyledLink } from 'components/Common/MasterComponents'
import { useProduct } from 'components/Pages/Wine/View/Main/_methods'
import {
  getWineSweetnessString,
  getWineTitleBrand,
  getWineTypeString,
} from 'utils/wine'
import Score from 'components/Common/Score'
import HelpTip from 'components/Common/Tooltips/HelpTip'
import { delimiter } from 'utils/consts/string'
import breakpoints from 'utils/consts/breakpoints'

const Wrapper = styled.div`
  grid-area: main-info;

  @media screen and ${breakpoints.device.tablet} {
    max-width: calc(100vw - 48px);
    margin-bottom: 24px;
  }

  @media screen and ${breakpoints.device.mobile} {
    max-width: calc(100vw - 32px);
    margin-bottom: 24px;
  }
`

const BrandLink = styled(StyledLink)`
  font: var(--typography-14-20-normal);
  word-break: break-word;
`

const ProductName = styled.h1`
  font: var(--typography-24-32-semibold);
  color: #121432;
  word-break: break-word;
  display: inline;
`

const MainSpecs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and ${breakpoints.device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;
  }
`

const WineSpecification = styled.div`
  font: var(--typography-14-20-normal);
  color: #121432;
`

const ScoreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 12px;
  margin-left: 12px;

  svg:not(:last-child) {
    margin-right: 2px;
  }

  @media screen and ${breakpoints.device.mobile} {
    padding-left: 0;
    margin-left: 0;
  }
`

const ScoreLabel = styled.div`
  margin: 0 8px;
  font: var(--typography-14-20-normal);
  color: #717284;
`

const TitleWrapper = styled.div`
  margin: 4px 0 12px;

  h1 {
    margin: 0;
  }

  svg {
    margin: 0 0 -3px 8px;
  }
`

const getWineSpecification = wine => {
  const wineColor = wine?.wineColor?.localizedName
  return [getWineTypeString(wine), wineColor, getWineSweetnessString(wine)]
    .filter(Boolean)
    .join(delimiter)
}

const MainInfo = () => {
  const { t } = useTranslation()
  const product = useProduct()
  const wine = product?.wine
  const rating = wine?.rating ?? 0

  return (
    <Wrapper>
      <BrandLink to={`/acc/producer/${wine?.tradeName?.id}`}>
        {wine?.tradeName?.tradeName}
      </BrandLink>

      <TitleWrapper>
        <ProductName>{getWineTitleBrand(wine)}</ProductName>
      </TitleWrapper>

      <MainSpecs>
        <WineSpecification>{getWineSpecification(wine)}</WineSpecification>
        {rating > 0 && (
          <ScoreWrapper>
            <Score value={rating} width={16} height={16} />
            <ScoreLabel>{t('wine.view.score')}</ScoreLabel>
            <HelpTip width={200} placement='bottom'>
              {t('wine.view.scoreTooltip')}
            </HelpTip>
          </ScoreWrapper>
        )}
      </MainSpecs>
    </Wrapper>
  )
}

export default MainInfo
